import { render, staticRenderFns } from "./AssetDataChip.vue?vue&type=template&id=f5e82fb8&scoped=true"
import script from "./AssetDataChip.vue?vue&type=script&lang=js"
export * from "./AssetDataChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e82fb8",
  null
  
)

export default component.exports